/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkTypeBreakdownDto } from '../../models/work-type-breakdown-dto';

export interface VolunteerStatsControllerGetTopWorkTypes$Params {
}

export function volunteerStatsControllerGetTopWorkTypes(http: HttpClient, rootUrl: string, params?: VolunteerStatsControllerGetTopWorkTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkTypeBreakdownDto>>> {
  const rb = new RequestBuilder(rootUrl, volunteerStatsControllerGetTopWorkTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WorkTypeBreakdownDto>>;
    })
  );
}

volunteerStatsControllerGetTopWorkTypes.PATH = '/volunteer-stats/top-work-types';
